import type {ReactElement} from 'react';
import React from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {useShowContextualSkeletons} from '@Hooks/poster-editor/useShowContextualSkeletons';
import BaseNavOption from '@Components/poster-editor/components/poster-editor-nav-bar/components/base-nav-option/base-nav-option';
import {onOpenResizeModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import type {NavRightSideOptionTypes} from '@Components/poster-editor/components/poster-editor-nav-bar/components/nav-right-options/nav-right-options.types';

export interface NavResizeOptionProps {
  resizeOptionType: NavRightSideOptionTypes;
}

export function NavResizeOption(props: NavResizeOptionProps): ReactElement {
  const showSkeletons = useShowContextualSkeletons();

  return showSkeletons ? (
    <div className={`spacing-p-3`}>
      <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={20} height={20} />
    </div>
  ) : (
    <BaseNavOption
      className="js-resize-btn"
      id="nav-resize-option"
      icon="icon-resize"
      text={window.i18next.t('pmwjs_resize')}
      optionType={props.resizeOptionType}
      onClickHandler={(): void => {
        onOpenResizeModal();
      }}
      hasMarginRight
    />
  );
}
